<template>
  <section class="order-seikyu">
    <validation-observer ref="observer" method="post">
      <table class="table">
        <tr>
          <th>
            会社名
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row">
              <div class="col-12 col-md-8 mb-2 mb-md-0">
                <validation-provider
                  v-slot="{ errors }"
                  name="SKS_KAISYA"
                  rules="required|max:20|char"
                >
                  <b-form-input
                    ref="SKS_KAISYA"
                    v-model="form.SKS_KAISYA"
                    maxlength="20"
                    :state="errors.length ? false : null"
                    placeholder="株式会社ロジコ"
                    trim
                    @blur="form.SKS_KAISYA = replaceChar(form.SKS_KAISYA)"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <button
                v-if="isFav"
                type="button"
                :class="['btn btn-success bold', { center: isMobile }]"
                @click="showFavListModal"
                style="height: 40px"
              >
                お気に入りから選択
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th>担当部署</th>
          <td>
            <validation-provider
              name="SKS_BUSYO"
              v-slot="{ errors }"
              rules="max:20|char"
            >
              <b-form-input
                ref="SKS_BUSYO"
                v-model="form.SKS_BUSYO"
                maxlength="20"
                :state="errors.length ? false : null"
                placeholder="経理部"
                trim
                @blur="form.SKS_BUSYO = replaceChar(form.SKS_BUSYO)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>郵便番号</th>
          <td>
            <div class="row">
              <div class="col-4 col-md-3">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:3"
                  name="SKS_YUBIN1"
                >
                  <b-form-input
                    ref="SKS_YUBIN1"
                    type="tel"
                    maxlength="3"
                    v-model="form.SKS_YUBIN1"
                    :state="errors.length ? false : null"
                    placeholder="160"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <span class="py-2">-</span>
              <div class="col-4 col-md-3">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:4"
                  name="SKS_YUBIN2"
                >
                  <b-form-input
                    ref="SKS_YUBIN2"
                    type="tel"
                    maxlength="4"
                    v-model="form.SKS_YUBIN2"
                    :state="errors.length ? false : null"
                    placeholder="0023"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <button
                type="button"
                class="btn btn-success bold"
                @click="searchAddress"
                :disabled="!isYubinSearch"
                style="height: 40px"
              >
                検索
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            都道府県・市区町村
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row">
              <div class="col-4 col-md-4 col-lg-3 pr-0">
                <validation-provider
                  name="SKS_TODO_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="SKS_TODO_CD"
                    v-model="form.SKS_TODO_CD"
                    :state="errors.length ? false : null"
                    :options="prefList"
                    trim
                    @change="changePref"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <div class="col-7 col-md-5 col-lg-4">
                <validation-provider
                  name="SKS_JYUSYO_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="SKS_JYUSYO_CD"
                    :disabled="!cityList.length"
                    v-model="form.SKS_JYUSYO_CD"
                    :state="errors.length ? false : null"
                    :options="cityList"
                    trim
                    @change="changeCity"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            番地建物名
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="SKS_JYUSYO1"
              v-slot="{ errors }"
              rules="required|max:25|char"
            >
              <b-form-input
                ref="SKS_JYUSYO1"
                maxlength="25"
                v-model="form.SKS_JYUSYO1"
                :state="errors.length ? false : null"
                placeholder="西新宿7－4－3 升本ビル4F"
                trim
                @blur="form.SKS_JYUSYO1 = replaceChar(form.SKS_JYUSYO1)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            担当者名
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="SKS_TANTO_MEI"
              v-slot="{ errors }"
              rules="required|max:20|char"
            >
              <b-form-input
                ref="SKS_TANTO_MEI"
                maxlength="20"
                v-model="form.SKS_TANTO_MEI"
                :state="errors.length ? false : null"
                placeholder="山田太郎"
                trim
                @blur="form.SKS_TANTO_MEI = replaceChar(form.SKS_TANTO_MEI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            TEL
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="SKS_TEL"
              v-slot="{ errors }"
              rules="required|tel"
            >
              <b-form-input
                ref="SKS_TEL"
                maxlength="17"
                v-model="form.SKS_TEL"
                :state="errors.length ? false : null"
                placeholder="03-5937-4777"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr v-if="isFav">
          <th>お気に入りに保存する</th>
          <td>
            <div class="ml-4 mt-2">
              <md-checkbox
                class="form-check-input md-primary"
                v-model="form.SKS_IS_FAVORITE_SAVE"
                :true-value="1"
                :false-value="0"
              >
                保存する
              </md-checkbox>
            </div>
          </td>
        </tr>
      </table>
    </validation-observer>
  </section>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import InvoiceListModal from '@/components/order/invoice/InvoiceListModal'
import Store from '@/store/index.js'
import Valid from '@/valid'
import _ from 'lodash'
import {validationMixin} from 'vuelidate'
const tel = (value) => Valid.isValidTel(value)
const isEmoji = (value) => Valid.isEmoji(value)

export default {
  name: 'InvoiceEdit',
  components: { InvoiceListModal },
  mixins: [validationMixin, Mixin],

  props: {
    /** バリデーション実行フラグ */
    isInvoiceValidActive: {
      type: Boolean,
      default: false,
    },

    /** 入力データ */
    parentForm: {
      type: Object,
      default: null,
    },

    /** お気に入り一覧編集か */
    isListEdit: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    /** 入力フォーム **/
    form: null,

    /** 市区町村リスト */
    cityList: [],

    /** オブザーバー */
    observer: null,
  }),

  mounted() {
    this.observer = this.$refs.observer
  },

  created() {
    this.setData()
  },

  methods: {
    /** 初期データを精製する */
    setData() {
      this.form = _.cloneDeep(this.parentForm)
      this.getCityList()
    },

    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.SKS_TODO_CD
      this.form.SKS_TODO = null
      this.form.SKS_JYUSYO_CD = ''
      this.form.SKS_SHIKU_MEI = null
      if (todoCd) {
        this.form.SKS_TODO = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.SKS_JYUSYO_CD
      this.form.SKS_SHIKU_MEI = null
      if (shikuCd) {
        this.form.SKS_SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.SKS_TODO_CD) return
      return Store.dispatch('address/getCityList', this.form.SKS_TODO_CD).then(
        () => {
          const cityList = _.cloneDeep(Store.state.address.cityList)
          cityList.unshift({
            value: '',
            text: '未選択',
          })
          this.cityList = cityList
        }
      )
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.SKS_YUBIN1}${this.form.SKS_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.SKS_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.SKS_TODO = this.getText(
            this.prefList,
            this.form.SKS_TODO_CD
          )
          this.form.SKS_SHIKU_MEI = item.address2
          this.form.SKS_JYUSYO1 = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.SKS_SHIKU_MEI,
            'text'
          )
          if (city) this.form.SKS_JYUSYO_CD = city.value
        }
      })
    },

    // お気に入りモーダル表示
    showFavListModal() {
      this.$emit('showFavListModal', true)
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.SKS_YUBIN1 &&
        this.form.SKS_YUBIN2 &&
        this.observer &&
        this.observer.fields.SKS_YUBIN1 &&
        this.observer.fields.SKS_YUBIN2 &&
        !this.observer.fields.SKS_YUBIN1.failed &&
        !this.observer.fields.SKS_YUBIN2.failed
      )
    },

    /** お気に入りを表示するか */
    isFav() {
      return !this.isListEdit && this.isLease
    },
  },

  watch: {
    /* 市区町村コード */
    'form.SKS_JYUSYO_CD'(val) {
      this.form.SKS_SHIKU_CD = val
    },

    /* バリデーション発火 */
    async isInvoiceValidActive(val) {
      if (val) {
        const result = await this.$refs.observer.validate()
        if (result) this.$emit('setInvoice', this.form)
        this.$emit('setIsInvoiceValid', result)
      }
    },

    /* 入力データ */
    parentForm: {
      handler: async function (val) {
        this.setData(val)
      },
      deep: true,
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
section.order-seikyu
  table
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
      padding: 1.5%
    td
      width: 68%
      background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/invoice/InvoiceEdit.vue